(function(){
  function qsa(root, sel){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(cents){
    var n = Number(cents || 0) / 100;
    return n.toLocaleString(undefined, { style:'currency', currency:(window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
  }
  function toast(message){
    var old = document.querySelector('.mzhp-toast');
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'mzhp-toast';
    el.innerHTML = message + ' <a href="/cart">View cart</a><a href="#" data-mzhp-toast-close>Continue shopping</a>';
    document.body.appendChild(el);
    var close = el.querySelector('[data-mzhp-toast-close]');
    if (close) close.addEventListener('click', function(e){ e.preventDefault(); el.remove(); });
    setTimeout(function(){ if (el.parentNode) el.remove(); }, 7000);
  }
  async function refreshCartCount(){
    try {
      var res = await fetch('/cart.js', { headers:{ Accept:'application/json' } });
      var cart = await res.json();
      qsa(document, '[data-cart-count], .cart-count-bubble span, #cart-icon-bubble span').forEach(function(node){ node.textContent = cart.item_count; });
    } catch(e) {}
  }
  async function addToCart(variantId, quantity, title){
    var res = await fetch('/cart/add.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json', Accept:'application/json' },
      body: JSON.stringify({ items:[{ id:Number(variantId), quantity: quantity || 1 }] })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    await refreshCartCount();
    document.dispatchEvent(new CustomEvent('cart:updated'));
    toast('Added to cart - ' + (title || 'MoomZee artwork'));
  }
  function closeModal(){ var m = document.querySelector('.mzhp-modal'); if (m) m.remove(); }
  function variantMatches(variant, selected){ return variant.options.every(function(value, index){ return selected[index] === value; }); }
  async function openVariantModal(handle){
    var res = await fetch('/products/' + handle + '.js', { headers:{ Accept:'application/json' } });
    if (!res.ok) { window.location.href = '/products/' + handle; return; }
    var product = await res.json();
    var modal = document.createElement('div');
    modal.className = 'mzhp-modal';
    var options = (product.options || []).map(function(option, index){
      var values = [];
      product.variants.forEach(function(v){ if (values.indexOf(v.options[index]) === -1) values.push(v.options[index]); });
      return '<label>' + option.name + '<select data-mzhp-option="' + index + '">' + values.map(function(v){ return '<option value="' + String(v).replace(/"/g,'&quot;') + '">' + v + '</option>'; }).join('') + '</select></label>';
    }).join('');
    modal.innerHTML = '<div class="mzhp-modal__box" role="dialog" aria-modal="true"><div class="mzhp-modal__head"><div><div class="mzhp-modal__title">' + product.title + '</div><div data-mzhp-modal-price>' + money(product.price) + '</div></div><button class="mzhp-btn secondary" type="button" data-mzhp-close style="width:auto;min-height:44px;padding:0 14px">Close</button></div><div>' + options + '</div><button class="mzhp-btn" type="button" data-mzhp-modal-add>Add To Cart</button></div>';
    document.body.appendChild(modal);
    function selected(){ return qsa(modal, '[data-mzhp-option]').map(function(sel){ return sel.value; }); }
    function currentVariant(){ return product.variants.find(function(v){ return variantMatches(v, selected()) && v.available; }) || product.variants.find(function(v){ return v.available; }); }
    function update(){
      var variant = currentVariant();
      modal.querySelector('[data-mzhp-modal-price]').textContent = variant ? money(variant.price) : 'Unavailable';
      modal.querySelector('[data-mzhp-modal-add]').disabled = !variant;
    }
    qsa(modal, 'select').forEach(function(sel){ sel.addEventListener('change', update); });
    modal.querySelector('[data-mzhp-close]').addEventListener('click', closeModal);
    modal.addEventListener('click', function(e){ if (e.target === modal) closeModal(); });
    modal.querySelector('[data-mzhp-modal-add]').addEventListener('click', async function(){
      var variant = currentVariant();
      if (!variant) return;
      await addToCart(variant.id, 1, product.title);
      closeModal();
    });
    update();
  }
  function initQuickAdd(root){
    qsa(root, '[data-mzhp-quick-add]:not([data-mzhp-bound])').forEach(function(btn){
      btn.dataset.mzhpBound = 'true';
      btn.addEventListener('click', async function(e){
        e.preventDefault();
        e.stopPropagation();
        try {
          if (btn.dataset.hasOptions === 'true') await openVariantModal(btn.dataset.productHandle);
          else await addToCart(btn.dataset.variantId, 1, btn.dataset.productTitle);
        } catch(err) {
          toast('Could not add this item. Please try again.');
        }
      });
    });
  }
  function initFavs(root){
    var favs;
    try { favs = JSON.parse(localStorage.getItem('moomzee_favorites') || '[]'); } catch(e) { favs = []; }
    qsa(root, '[data-mzhp-fav]:not([data-mzhp-bound])').forEach(function(btn){
      btn.dataset.mzhpBound = 'true';
      var id = btn.dataset.productId;
      btn.setAttribute('aria-pressed', favs.indexOf(id) !== -1 ? 'true' : 'false');
      btn.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var i = favs.indexOf(id);
        if (i === -1) favs.push(id); else favs.splice(i, 1);
        localStorage.setItem('moomzee_favorites', JSON.stringify(favs));
        btn.setAttribute('aria-pressed', favs.indexOf(id) !== -1 ? 'true' : 'false');
      });
    });
  }
  function initTabs(root){
    qsa(root, '[data-mzhp-tabs]:not([data-mzhp-bound])').forEach(function(box){
      box.dataset.mzhpBound = 'true';
      var tabs = qsa(box, '[data-mzhp-tab]');
      var panels = qsa(box, '[data-mzhp-panel]');
      var cta = box.querySelector('[data-mzhp-tab-cta]');
      tabs.forEach(function(tab){
        tab.addEventListener('click', function(){
          var key = tab.dataset.mzhpTab;
          tabs.forEach(function(t){ t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          panels.forEach(function(p){ p.classList.toggle('is-active', p.dataset.mzhpPanel === key); });
          if (cta) {
            cta.textContent = tab.dataset.ctaLabel || cta.textContent;
            cta.href = tab.dataset.ctaUrl || '#';
          }
        });
      });
    });
  }
  function initFaq(root){
    qsa(root, '[data-mzhp-faq-item]:not([data-mzhp-bound])').forEach(function(item){
      item.dataset.mzhpBound = 'true';
      var btn = item.querySelector('[data-mzhp-faq-q]');
      if (!btn) return;
      btn.addEventListener('click', function(){
        var open = item.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }
  function initKlaviyo(root){
    qsa(root, '[data-mzhp-klaviyo]:not([data-mzhp-bound])').forEach(function(form){
      form.dataset.mzhpBound = 'true';
      form.addEventListener('submit', async function(e){
        e.preventDefault();
        var input = form.querySelector('input[name="email"]');
        var email = input ? (input.value || '').trim() : '';
        var list = form.dataset.list;
        var company = form.dataset.company;
        var button = form.querySelector('button');
        if (!email) return;
        if (!list || !company) {
          form.outerHTML = form.dataset.success || '<p>Thank you. Please check your inbox.</p>';
          return;
        }
        try {
          var res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
            method:'POST',
            headers:{ 'Content-Type':'application/json', revision:'2024-10-15' },
            body: JSON.stringify({ data:{ type:'subscription', attributes:{ custom_source:'Homepage - Size & Hanging Guide', profile:{ data:{ type:'profile', attributes:{ email:email } } } }, relationships:{ list:{ data:{ type:'list', id:list } } } } })
          });
          if (res.ok) form.outerHTML = form.dataset.success || '<p>Thank you. Please check your inbox.</p>';
          else if (button) button.textContent = 'Try again';
        } catch(err) {
          if (button) button.textContent = 'Try again';
        }
      });
    });
  }
  function init(root){
    root = root || document;
    initQuickAdd(root);
    initFavs(root);
    initTabs(root);
    initFaq(root);
    initKlaviyo(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function(event){ init(event.target); });
})();